import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import VideoEmbed from 'components/VideoEmbed';
import AddAFriendIcon from './assets/AddAFriend_159x150.png';
import AllMineIcon from './assets/AllMine_159x150.png';
import AutoAdvanceIcon from './assets/AutoAdvance_159x150.png';
import AutoAdvancePlusIcon from './assets/AutoAdvance_Plus_159x150.png';
import AutoWinIcon from './assets/AutoWin_159x150.png';
import BouncebackIcon from './assets/BounceBack_159x150.png';
import CashIsKingIcon from './assets/CashIsKing_159x150.png';
import DeckedOutIcon from './assets/DeckedOut_159x150.png';
import DoOverIcon from './assets/DoOver_159x150.png';
import ExtraEntriesIcon from './assets/ExtraEntries_159x150.png';
import ExtraExtraIcon from './assets/ExtraExtra_159x150.png';
import FirstPickIcon from './assets/FirstPick_159x150.png';
import FreeEntryIcon from './assets/FreeEntry_159x150.png';
import FreeFoodFrenzyIcon from './assets/FreeFoodFrenzy_159x150.png';
import FreeForMeIcon from './assets/FreeForMe_159x150.png';
import JetSetter from './assets/JetSetter_159x150.png';
import MysteryBoxIcon from './assets/MysteryBox_159x150.png';
import OhSnapIcon from './assets/OhSnap_159x150.png';
import PrizeBoosterIcon from './assets/PrizeBooster_159x150.png';
import PrizeDoublerIcon from './assets/PrizeDoubler_159x150.png';
import PrizeMultiplierIcon from './assets/PrizeMultiplier_159x150.png';
import PromoPerksLogo from './assets/PromoPerksLogo.png';
import ShareTheWinIcon from './assets/ShareTheWin_159x150.png';
import StandBy from './assets/StandBy_159x150.png';
import TriggeredIcon from './assets/Triggered_159x150.png';
import VirtualWinIcon from './assets/VirtualWin_159x150.png';
import WaterfallIcon from './assets/Waterfall_159x150.png';
import WinFromHomeIcon from './assets/WinFromHome_159x150.png';
import './PromoPerksContent.css';

const WSTORE_LINK_TO = {
  pathname: '/wstore',
  state: {
    categoryValue: 'A - Promo Perk',
    initiator: 'promo-perks-wstore-button'
  }
};

const PROMO_PERKS_VIDEO_ID = 'Ciy7PTpRxmY';

class PromoPerksContent extends PureComponent {
  constructor(props) {
    super(props);

    this.perkData = [
      {
        title: 'FREE FOR ME',
        description:
          'Redeem a Free For Me Perk and you’ll get the specified item or gift for FREE.',
        icon: FreeForMeIcon
      },
      {
        title: 'PRIZE MULTIPLIER',
        description:
          'With the Prize Multiplier Perk, if you win, your prize will be multiplied up to 10X!',
        icon: PrizeMultiplierIcon
      },
      {
        title: 'AUTO ADVANCE',
        description:
          'With an Auto Advance Perk, if you qualify in an early-round during the designated promotion, you’ll automatically advance to the next round.',
        icon: AutoAdvanceIcon
      },
      {
        title: 'AUTO ADVANCE+',
        description:
          'Get an Auto Advance+ Perk and you’ll automatically qualify for the Grand Prize drawing in the specified promotion, even if your name isn’t drawn.',
        icon: AutoAdvancePlusIcon
      },
      {
        title: 'AUTO WIN',
        description:
          'Redeem this Perk, meet the on-property tier-point requirements, and automatically win the top prize!',
        icon: AutoWinIcon
      },
      {
        title: 'PRIZE BOOSTER',
        description:
          'If you have a Prize Booster Perk and you win, your prize is boosted with extra CASH, FREE Play or Holiday Shopping Dollars.',
        icon: PrizeBoosterIcon
      },
      {
        title: 'PRIZE DOUBLER',
        description:
          'Redeem this Perk and meet the on-property tier-point requirements. Then win and double your prize!',
        icon: PrizeDoublerIcon
      },
      {
        title: 'PICK 1ST',
        description:
          'With a Pick 1st Perk, if you win in the designated promotion you will get to choose your prize option first, regardless of the order in which you were drawn.',
        icon: FirstPickIcon
      },
      {
        title: 'VIRTUAL WIN',
        description:
          'A Virtual Win Perk will enable you to participate in the drawing no matter where you are, if we can contact you. Additional rules apply.',
        icon: VirtualWinIcon
      },
      {
        title: 'WIN FROM HOME',
        description:
          'Get a Win From Home Perk so you don’t have to be present to win during the promotion.',
        icon: WinFromHomeIcon
      },
      {
        title: 'ADD A FRIEND',
        description:
          'With an Add A Friend Perk, if you win a prize in the promotion, you can choose a friend to win a special prize, too.',
        icon: AddAFriendIcon
      },
      {
        title: 'SHARE THE WIN',
        description:
          'Win a prize in a specific promotion and Wind Creek will make a donation to a charity in your name.',
        icon: ShareTheWinIcon
      },
      {
        title: 'MYSTERY BOX',
        description:
          'A Mystery Box Perk will give you the option of keeping any prize you win, or you can exchange it for a Mystery Box that is filled with CASH, prize multipliers or other great prizes.',
        icon: MysteryBoxIcon
      },
      {
        title: 'OH SNAP!',
        description:
          'Get an Oh Snap! Perk, then check-in with the Promotions team prior to the promotion and automatically become a winner.',
        icon: OhSnapIcon
      },
      {
        title: 'CASH IS KING',
        description:
          'If you have a Cash is King Perk and you win a non-cash prize, you can exchange your prize for CASH equaling the value of the prize.',
        icon: CashIsKingIcon
      },
      {
        title: 'WATERFALL',
        description:
          "Get a Waterfall Perk and if you win, you'll guarantee your spot in the same promotion each week as a winner.",
        icon: WaterfallIcon
      },
      {
        title: 'EXTRA ENTRIES',
        description:
          'Extra Entries Perks will give you more entries into the drawing.',
        icon: ExtraEntriesIcon
      },
      {
        title: 'EXTRA EXTRA',
        description:
          'An Extra Extra Perk will give you an entry multiplier of entries into the drawing.',
        icon: ExtraExtraIcon
      },
      {
        title: 'FREE ENTRY',
        description:
          'A FREE Entry Perk will give you a FREE entry into designated events, tournaments or drawings at any of our casino locations.',
        icon: FreeEntryIcon
      },
      {
        title: 'DECKED-OUT',
        description:
          'Redeem a Decked-Out Perk for a specified event, then pick up your Perk at the casino so you can stand out at the occasion!',
        icon: DeckedOutIcon
      },
      {
        title: 'FREE FOOD FRENZY',
        description:
          'With this Perk, if you win you will automatically get a Food Credit!',
        icon: FreeFoodFrenzyIcon
      },
      {
        title: 'TRIGGERED',
        description:
          'Get the Triggered Perk to win FREE Play and set off your very own Hot Seat promotion at the specified casino.',
        icon: TriggeredIcon
      },
      {
        title: 'ALL MINE',
        description:
          'If you have an All Mine Perk and your name is drawn in any round, you’ll win all of the prizes available in that round!',
        icon: AllMineIcon
      },
      {
        title: 'JETSETTER',
        description: 'Expedite your team’s passports at no cost to you!',
        icon: JetSetter
      },
      {
        title: 'STAND BY',
        description:
          'Move up to the Championship Tournament if a winning team can’t go!',
        icon: StandBy
      },
      {
        title: 'BOUNCEBACK',
        description:
          'Win during a promotion and get a second prize on a future visit.',
        icon: BouncebackIcon
      },
      {
        title: 'DO OVER',
        description: 'Win then get a chance to win again.',
        icon: DoOverIcon
      }
    ];
  }

  render() {
    return (
      <div className="promo-perks-content">
        <Helmet>
          <title>Promo Perks</title>
        </Helmet>
        {this.renderSummary()}
        <div className="perks-content-right-panel">
          {this.renderPerks()}
          {this.renderFooter()}
        </div>
      </div>
    );
  }

  renderSummary() {
    return (
      <div className="promo-summary">
        <div className="promo-video-container">
          <VideoEmbed
            thumbnail={PromoPerksLogo}
            videoId={PROMO_PERKS_VIDEO_ID}
            title="Introduction to Promo Perks"
            deactivateOnEnd
          />
        </div>
        <div className="promo-text">
          Wind Creek Rewards is thrilled to introduce exciting new ways to perk
          up your play at Wind Creek - Promo Perks! Promo Perks can be acquired
          through your online play and will help you get MORE out of many of our
          casino promotions.
        </div>
        <div className="promo-wstore-container">
          <div className="action-text">
            Get Promo Perks from the WStore Now!
          </div>
          <Link className="btn button-color-green" to={WSTORE_LINK_TO}>
            WStore
          </Link>
        </div>
      </div>
    );
  }

  renderPerks() {
    return (
      <div className="perk-list">
        {this.perkData.map((perk, index) => (
          <div className="perk-entry" key={index}>
            <img src={perk.icon} alt="" />
            <div className="perk-title">{perk.title}</div>
            <div className="perk-description">{perk.description}</div>
          </div>
        ))}
      </div>
    );
  }

  renderFooter() {
    return (
      <div className="perk-footer">
        Promo Perks are not available for every on-property promotion. When
        available, Promo Perks will differ from promotion to promotion. Promo
        Perks are limited. Dates of availability may differ between Perks and
        promotions.
        <span>Gambling problem? Call 1-800-GAMBLER</span>
      </div>
    );
  }
}

export default PromoPerksContent;
